import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-the-a05-point-notification-panel-thanks__header" }
const _hoisted_2 = { class: "p-the-a05-point-notification-panel-thanks__image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "p-the-a05-point-notification-panel-thanks__summary" }
const _hoisted_5 = {
  key: 0,
  class: "p-the-a05-point-notification-panel-thanks__badge-name",
  "data-translate-skip": ""
}
const _hoisted_6 = {
  class: "p-the-a05-point-notification-panel-thanks__title",
  "data-translate-skip": ""
}
const _hoisted_7 = {
  class: "p-the-a05-point-notification-panel-thanks__message",
  "data-translate-skip": ""
}
const _hoisted_8 = { class: "p-the-a05-point-notification-panel-thanks__footer" }
const _hoisted_9 = {
  class: "p-the-a05-point-notification-panel-thanks__point-badge",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconNotificationThanks = _resolveComponent("IconNotificationThanks")!

  return (_openBlock(), _createElementBlock("div", {
    class: "p-the-a05-point-notification-panel-thanks",
    style: _normalizeStyle({ background: _ctx.colorCode })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasBadge)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.badgeIcon,
              class: "p-the-a05-point-notification-panel-thanks__badge-image"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createBlock(_component_IconNotificationThanks, {
              key: 1,
              "icon-size": 62
            }))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.hasBadge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.badgeName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.message), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.addComma(_ctx.point)) + " " + _toDisplayString(_ctx.unit.point), 1)
    ])
  ], 4))
}